import React, { useState } from 'react';
import MultipleVideosCarousel from './carruselVideoPages';
import WhatsApp from '@mui/icons-material/WhatsApp';
import {
  AppBar,
  Box,
  Button,
  Card,
  CardMedia,
  Container,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
  styled,
} from '@mui/material';
import {
  ArrowForward,
  KeyboardArrowDown,
  Code,
  SupportAgent,
  Lock,
  Rocket,
  Star,
  Security,
} from '@mui/icons-material';


// Componentes personalizados con estilos más parecidos a Tailwind
const GradientAppBar = styled(AppBar)(({ theme }) => ({
  background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
  boxShadow: theme.shadows[4],
}));

const GradientBox = styled(Box)(({ theme }) => ({
  background: `linear-gradient(180deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
  color: theme.palette.primary.contrastText,
}));

const RoundedButton = styled(Button)(({ theme, color = 'primary' }) => ({
  borderRadius: '9999px',
  textTransform: 'none',
  fontWeight: 600,
  boxShadow: theme.shadows[2],
  '&:hover': {
    boxShadow: theme.shadows[4],
  },
}));

const TabButton = styled(Button)(({ theme, active }) => ({
  borderRadius: '9999px',
  padding: '8px 16px',
  fontWeight: 500,
  backgroundColor: active ? theme.palette.primary.main : theme.palette.grey[200],
  color: active ? theme.palette.primary.contrastText : theme.palette.text.secondary,
  '&:hover': {
    backgroundColor: active ? theme.palette.primary.dark : theme.palette.grey[300],
  },
}));


const services = {
  streamingsoft: {
    title: "StreamingSoft App",
    description: "Aplicación móvil Android en play store y para Windows que ayuda a gestionar la venta de servicios digitales de plataformas de streaming como Netflix, Disney+, Max, Prime Video y más.",
    benefits: [
      "Gestión centralizada de tus ventas de servicios streaming",
      "Interfaz intuitiva y fácil de usar",
      "Reportes detallados de tus ventas y cuentas",
      "Seguimiento de suscripciones, renovaciones de clientes y más",
      "Reportes de ganancias en diferentes periodos",
      "Envio de tickets y recordatorios de pago de manera sencilla por WhatsApp",
      "Filtra y busca cuentas por diferentes criterios"
    ],
    cta: "Más información StreamingSoft",
    ctaUrl: "https://api.whatsapp.com/send?phone=5213122145108&text=Hola%2C%20buen%20d%C3%ADa.%20Me%20interesa%2C%20%C2%BFpodr%C3%ADas%20darme%20m%C3%A1s%20informaci%C3%B3n%20sobre%20StreamingSoft%20App%3F",
    videoUrl: "https://streamingsoft.com/StreamingSoftWeb/Assets/StreamingSoftApp/video-1.mp4",
    screenshots: [
      "https://streamingsoft.com/StreamingSoftWeb/Assets/StreamingSoftApp/1.jpg",
      "https://streamingsoft.com/StreamingSoftWeb/Assets/StreamingSoftApp/2.jpg",
      "https://streamingsoft.com/StreamingSoftWeb/Assets/StreamingSoftApp/3.jpg",
      "https://streamingsoft.com/StreamingSoftWeb/Assets/StreamingSoftApp/4.jpg",
      "https://streamingsoft.com/StreamingSoftWeb/Assets/StreamingSoftApp/5.jpg",
    ]
  },
  whatsappbot: {
    title: "Bot de WhatsApp",
    description: "Automatiza la atención al cliente y mejora tus ventas con nuestro bot personalizado para WhatsApp Business.",
    benefits: [
      "Atención 24/7 a tus clientes",
      "Respuestas automáticas a preguntas frecuentes",
      "*Integración con tu catálogo de servicios y StreamingSoft App",
      "*Envío automatico de recordatorios de pagos y renovaciones",
      "*Envío automatico de tickets",
      "*Integración con IA para respuestas más inteligentes y personalizadas"
    ],
    cta: "Solicita tu Bot",
    ctaUrl: "https://api.whatsapp.com/send?phone=5213122145108&text=Hola%2C%20buen%20d%C3%ADa.%20Me%20interesa%2C%20%C2%BFpodr%C3%ADas%20darme%20m%C3%A1s%20informaci%C3%B3n%20sobre%20los%20bots%20para%20whatsapp%3F",
    videos: [
      "https://streamingsoft.com/StreamingSoftWeb/Assets/BotWhatsapp/video-3.mp4",
      "https://streamingsoft.com/StreamingSoftWeb/Assets/BotWhatsapp/video-1.mp4",
      "https://streamingsoft.com/StreamingSoftWeb/Assets/BotWhatsapp/video-2.mp4"
    ],
    screenshots: [
      "https://streamingsoft.com/StreamingSoftWeb/Assets/BotWhatsapp/1.jpg",
      "https://streamingsoft.com/StreamingSoftWeb/Assets/BotWhatsapp/2.jpg",
      "https://streamingsoft.com/StreamingSoftWeb/Assets/BotWhatsapp/3.jpg"
    ]
  },
  verificationpanel: {
    title: "Panel de Códigos",
    description: "Panel web-app y bot para la obtención de códigos de verificación de Netflix y Disney+, ideal para validar cuentas 'Estoy de Viaje' e 'Inicio de sesion'.",
    benefits: [
      "Generación automática de códigos de verificación",
      "Interfaz web intuitiva para gestionar solicitudes",
      "Integracion con sitios webs o apliaciones moviles ya existentes",
      "Reducción de tiempo en la gestión de verificaciones"
    ],
    cta: "Ver Demostración",
    ctaUrl: "codigos.bretro.tech",
    videoUrl: null,
    screenshots: [
      "https://streamingsoft.com/StreamingSoftWeb/Assets/PanelCodigos/1.jpg",
      "https://streamingsoft.com/StreamingSoftWeb/Assets/PanelCodigos/2.jpg",
      "https://streamingsoft.com/StreamingSoftWeb/Assets/PanelCodigos/3.jpg",
      "https://streamingsoft.com/StreamingSoftWeb/Assets/PanelCodigos/4.jpg"
    ]
  },
  tiendaOnline: {
    title: "Tienda Online",
    description: "Aplicación móvil Android y/o sitio web personalizado para la venta automatizada de servicios digitales 24/7, sin necesidad de atención manual constante.",
    benefits: [
      "Ventas automatizadas 24/7 incluso mientras duermes",
      "Panel administrativo completo para gestionar productos e inventario",
      "Entrega automática del ticket con datos de acceso a lo clientes tras la compra",
      "Estadísticas detalladas y reportes de ventas en tiempo real",
      "Gestion de reportes y fallos",
      "Diseño personalizado adaptado a tu marca",
      "Integracion con playstore para descarga de la app"
    ],
    cta: "Solicita tu Tienda Online",
    ctaUrl: "https://api.whatsapp.com/send?phone=5213122145108&text=Hola%2C%20buen%20d%C3%ADa.%20Me%20interesa%2C%20%C2%BFpodr%C3%ADas%20darme%20m%C3%A1s%20informaci%C3%B3n%20sobre%20hacer%20mi%20tienda%20online%3F",
    videoUrl: "https://streamingsoft.com/StreamingSoftWeb/Assets/TiendaOnline/video-1.mp4",
    screenshots: [
      "https://streamingsoft.com/StreamingSoftWeb/Assets/TiendaOnline/1.jpg",
      "https://streamingsoft.com/StreamingSoftWeb/Assets/TiendaOnline/2.jpg",
      "https://streamingsoft.com/StreamingSoftWeb/Assets/TiendaOnline/3.jpg",
      "https://streamingsoft.com/StreamingSoftWeb/Assets/TiendaOnline/4.jpg",
      "https://streamingsoft.com/StreamingSoftWeb/Assets/TiendaOnline/5.jpg",
      "https://streamingsoft.com/StreamingSoftWeb/Assets/TiendaOnline/6.jpg"
    ]
  },
  digitalcreation: {
    title: "Soluciones Digitales",
    description: "Desarrollo de sitios web, aplicaciones móviles, implementaciones de IA y soluciones digitales enfocadas a la venta de servicios de streaming o cualquier negocio.",
    benefits: [
      "Soluciones personalizadas según tus necesidades",
      "Desarrollo multiplataforma con tecnologías modernas",
      "Diseños respónsive, intuitivos y fáciles de usar",
      "Soporte técnico continuo",
      "Nos adaptamos a tu presupuesto y plazos de entrega"
    ],
    cta: "Contactanos y desarrolla tu idea",
    ctaUrl: "https://api.whatsapp.com/send?phone=5213122145108&text=Hola%2C%20buen%20d%C3%ADa%20tengo%20una%20idea%20en%20mente%20y%20me%20gustaria%20desarrollarla.",
    videoUrl: null,
    screenshots: [
      "https://empleotecnia.com/wp-content/uploads/2024/03/1Rsbdz5dQhqbtrTrsOn_9g.webp",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ0vrhfVRwQp4RC57j84veNf4Jym2ur3GqdeQ&s",
      "https://t21.com.mx/wp-content/uploads/2024/08/Inteligencia-artificial-1.jpg",
      "https://www.qualitydevs.com/wp-content/uploads/2021/03/Desarrollo-apps-moviles.jpg",
      "https://zamundi.com/wp-content/uploads/2019/12/code-1839406_1920.jpg",
      "https://bedu-staging-assets.s3.us-west-2.amazonaws.com/ULA/ula_web_desktop_img_oferta_edu_filtro_licenciaturas_ejecutivas_ing_desarrollo_software_b8f98140f0.jpg"

    ]
  }
};

const LandingPage = () => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  const servicesArray = Object.keys(services).map(key => ({ id: key, ...services[key] }));
  const activeService = servicesArray[activeTabIndex];

  const handleTabClick = (index) => {
    setActiveTabIndex(index);
  };

    // Función para renderizar el contenido multimedia según el servicio
    const renderMediaContent = (service) => {
      if (service.id === 'whatsappbot' && service.videos && service.videos.length > 0) {
        return (
          <MultipleVideosCarousel videos={service.videos} title={service.title} />
        );
      } else if (service.videoUrl) {
        return (
          <Box sx={{ position: 'relative', mb: 3 }}>
            <CardMedia
              component="video"
              src={service.videoUrl}
              controls
              alt={`Video de ${service.title}`}
              sx={{ 
                borderRadius: 2, 
                boxShadow: 3,
                width: '100%',
                height: 'auto',
                maxHeight: 400,
                objectFit: 'contain'
              }}
            />
          </Box>
        );
      }
      return null;
    };
  

  return (
    <Box sx={{ flexGrow: 1 }}>
      {/* Header / AppBar */}
      <GradientAppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
            StreamingSoft
          </Typography>
          {!isMobile && (
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button color="inherit" href="#servicios" sx={{ '&:hover': { color: '#bbdefb' } }}>Servicios</Button>
              <Button color="inherit" href="#clientes" sx={{ '&:hover': { color: '#bbdefb' } }}>Clientes</Button>
              <Button color="inherit" href="#contacto" sx={{ '&:hover': { color: '#bbdefb' } }}>Contacto</Button>
            </Box>
          )}
          <RoundedButton 
            variant="contained"
            color="inherit"
            endIcon={<ArrowForward />}
            sx={{ 
              ml: 2, 
              bgcolor: 'white',
              color: theme.palette.primary.main,
              '&:hover': { bgcolor: '#f5f5f5' }
            }}
            href="#contacto"
          >
            Contactanos
          </RoundedButton>
        </Toolbar>
      </GradientAppBar>

      {/* Hero Section */}
      <GradientBox sx={{ py: 8, textAlign: 'center' }}>
        <Container>
          <Typography variant="h4" component="h1" gutterBottom fontWeight="bold" sx={{ mb: 2 }}>
            Soluciones digitales personalizadas a tus necesidades para la venta de servicios de streaming
          </Typography>
          <Typography variant="h6" paragraph sx={{ mb: 4, maxWidth: '800px', mx: 'auto' }}>
            Optimiza tus ventas de servicios de streaming con nuestras herramientas especializadas
          </Typography>
          <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
            <RoundedButton 
              variant="contained" 
              color="inherit" 
              size="large" 
              sx={{ 
                bgcolor: 'white', 
                color: theme.palette.primary.main,
                px: 3,
                py: 1.5,
                fontSize: '1.1rem'
              }}
              href="#servicios" 
            >
              Ver Servicios
            </RoundedButton>
          </Box>
        </Container>
      </GradientBox>

      {/* Services Section */}
      <Container id="servicios" sx={{ py: 8 }}>
        <Typography variant="h4" component="h2" align="center" gutterBottom sx={{ mb: 6, fontWeight: 'bold' }}>
          Algunos de nuestros servicios
        </Typography>
        
        {/* Service Tabs - similar to the Tailwind buttons */}
        <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 1, mb: 5 }}>
          {servicesArray.map((service, index) => (
            <TabButton
              key={service.id}
              active={activeTabIndex === index}
              onClick={() => handleTabClick(index)}
            >
              {service.title}
            </TabButton>
          ))}
        </Box>
        
 {/* Service Content */}
 <Paper 
          elevation={4} 
          sx={{ 
            borderRadius: 3,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ p: { xs: 3, md: 4 } }}>
            <Typography variant="h5" component="h3" gutterBottom fontWeight="bold" color="text.primary">
              {activeService.title}
            </Typography>
            <Typography paragraph color="text.secondary" sx={{ mb: 4 }}>
              {activeService.description}
            </Typography>
            
            <Grid container spacing={4}>
              {/* Left column: Benefits */}
              <Grid item xs={12} md={6}>
                <Typography variant="h6" gutterBottom fontWeight="600" color="text.primary">
                  Beneficios
                </Typography>
                <List disablePadding>
                  {activeService.benefits.map((benefit, i) => (
                    <ListItem key={i} sx={{ py: 0.75 }}>
                      <ListItemIcon sx={{ minWidth: 36 }}>
                        <Box 
                          sx={{ 
                            bgcolor: 'primary.50', 
                            p: 0.5, 
                            borderRadius: '50%', 
                            display: 'flex'
                          }}
                        >
                          <KeyboardArrowDown color="primary" fontSize="small" />
                        </Box>
                      </ListItemIcon>
                      <ListItemText primary={benefit} primaryTypographyProps={{ color: 'text.secondary' }} />
                    </ListItem>
                  ))}
                </List>
                
                <Button 
                  variant="contained" 
                  color="primary" 
                  endIcon={<ArrowForward />}
                  sx={{ 
                    mt: 4,
                    py: 1.5,
                    px: 3,
                    borderRadius: 2,
                    fontWeight: 600,
                    boxShadow: 4
                  }}
                  onClick={() => window.open(activeService.ctaUrl, '_blank')}
                >
                  {activeService.cta}
                </Button>
              </Grid>
              
              {/* Right column: Media */}
              <Grid item xs={12} md={6}>
                {/* Renderizamos el contenido multimedia según el servicio */}
                {renderMediaContent(activeService)}
                
                <Grid container spacing={2}>
                  {activeService.screenshots.map((screenshot, i) => (
                    <Grid item xs={6} sm={4} key={i}>
                      <CardMedia
                        component="img"
                        image={screenshot}
                        alt={`Captura ${i + 1} de ${activeService.title}`}
                        sx={{ 
                          borderRadius: 2, 
                          boxShadow: 1, 
                          height: 'auto',
                          transition: 'all 0.3s ease',
                          cursor: 'pointer',
                          '&:hover': {
                            transform: 'scale(1.05)',
                            boxShadow: 3
                          }
                        }}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Container>
      
      
      {/* Features Section with Icons - styled exactly like the Tailwind version */}
      <Box sx={{ bgcolor: 'grey.100', py: 8 }}>
        <Container>
          <Typography variant="h4" component="h2" align="center" gutterBottom sx={{ mb: 6, fontWeight: 'bold' }}>
            ¿Por qué elegirnos?
          </Typography>
          
          <Grid container spacing={4}>
            {[
              { 
                icon: <Lock sx={{ fontSize: 28, color: 'white' }} />, 
                title: "Proteccion de datos", 
                desc: "Implementamos cifrado y medidas de seguridad avanzadas para proteger la información de tus clientes y las cuentas."
              },
              { 
                icon: <Rocket sx={{ fontSize: 28, color: 'white' }} />, 
                title: "Velocidad y Eficiencia", 
                desc: "Nuestras soluciones están diseñadas para ser rápidas, eficientes y fáciles de usar para tu equipo y tus clientes."
              },
              { 
                icon: <SupportAgent sx={{ fontSize: 28, color: 'white' }} />, 
                title: "Asistencia Técnica",
                desc: "Soporte técnico continuo para garantizar satisfaccion en tu servicio y resolver cualquier problema que surja." 
              },
              { 
                icon: <Star sx={{ fontSize: 28, color: 'white' }} />, 
                title: "Personalización, Diseño intuitivo y atractivo",
                desc: "Diseños y soluciones personalizadas para adaptarse a tu marca y tus necesidades específicas." 
              },
              { 
                icon: <Security sx={{ fontSize: 28, color: 'white' }} />, 
                title: "Seguridad, confianza y calidad",
                desc: "Garantizamos la seguridad, calidad y confianza de nuestros trabajos, ya que hemos trabajado con varios clientes satisfechos." 
              },
              { 
                icon: <Code sx={{ fontSize: 28, color: 'white' }} />, 
                title: "Desarrollos especializados en ventas de servicios digitales",
                desc: "Nos especializamos en el desarrollo de soluciones para la venta de servicios digitales, contando amplia experiencia en el sector." 
              }
            ].map((feature, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card 
                  elevation={1}
                  sx={{ 
                    borderRadius: 2,
                    p: 4,
                    height: '100%',
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      boxShadow: 4
                    }
                  }}
                >
                  <Box 
                    sx={{ 
                      width: 70,
                      height: 70,
                      borderRadius: '50%',
                      bgcolor: '#4299e1',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      mb: 2
                    }}
                  >
                    {feature.icon}
                  </Box>
                  <Typography 
                    variant="h6" 
                    component="h3" 
                    gutterBottom 
                    sx={{
                      fontWeight: 'bold',
                      fontSize: '1.25rem',
                      mb: 1,
                      color: '#333'
                    }}
                  >
                    {feature.title}
                  </Typography>
                  <Typography 
                    variant="body2" 
                    sx={{
                      color: '#666',
                      textAlign: 'center',
                      lineHeight: 1.6
                    }}
                  >
                    {feature.desc}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

        {/* Clients Section */}
        <Box id="clientes" sx={{ py: 8 }}>
        <Container>
          <Typography variant="h4" component="h2" align="center" gutterBottom sx={{ mb: 6, fontWeight: 'bold' }}>
            Nuestros Clientes
          </Typography>
          <Typography variant="h6" paragraph sx={{ maxWidth: '800px', mx: 'auto', mb: 6, textAlign: 'center', color: 'text.secondary' }}>
            Estos son algunos de los clientes que han confiado en nuestras soluciones para potenciar su negocio de streaming
          </Typography>
          
          <Grid container spacing={4} justifyContent="center">
            {[
              { 
                name: "PlayFy", 
                logo: "https://streamingsoft.com/StreamingSoftWeb/Assets/LogoClientes/playfy.png",
                testimonial: "StreamingSoft me ha ayudado bastante a reducir tiempos, ya que tengo una mejor gestions de mis clientes, ventas y sobre todo las renovaciones."
              },
              { 
                name: "DigitalVnhe", 
                logo: "https://streamingsoft.com/StreamingSoftWeb/Assets/LogoClientes/vnhe.png",
                testimonial: "El desarrollo de nuestra app movil con notificaciones fue una solucíon perfecta para nuestro negocio, ya que ahora podemos avisar cuando hay promociones y nuevos servicios"
              },
              { 
                name: "Spaceflix", 
                logo: "https://streamingsoft.com/StreamingSoftWeb/Assets/LogoClientes/spaceflix.png",
                testimonial: "Tener mi propia tienda online cmabio por completo nuestra operación, ahora podemos vender servicios 24/7 y nos ayudo basante a crecer en ventas."
              },
              { 
                name: "StreamingPro", 
                logo: "https://streamingsoft.com/StreamingSoftWeb/Assets/LogoClientes/streamingpro.png",
                testimonial: "El panel para códigos ha reducido en un 80% el tiempo que dedicábamos a la gestión de códigos."
              }
            ].map((client, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card 
                  elevation={2}
                  sx={{ 
                    borderRadius: 2,
                    p: 3,
                    height: '100%',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      boxShadow: 4
                    }
                  }}
                >
                  <Box sx={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center', 
                    height: '100%',
                    justifyContent: 'space-between'
                  }}>
                    <CardMedia
                      component="img"
                      image={client.logo}
                      alt={`Logo de ${client.name}`}
                      sx={{ 
                        height: 80, 
                        objectFit: 'contain',
                        mb: 3,
                        transition: 'all 0.3s ease',
                      }}
                    />
                    <Box>
                      <Typography 
                        variant="body2" 
                        sx={{
                          color: '#666',
                          textAlign: 'center',
                          lineHeight: 1.6,
                          fontStyle: 'italic',
                          mb: 2
                        }}
                      >
                        "{client.testimonial}"
                      </Typography>
                      <Typography 
                        variant="subtitle2" 
                        sx={{
                          fontWeight: 'bold',
                          textAlign: 'center',
                          color: 'primary.main'
                        }}
                      >
                        {client.name}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
          
        </Container>
      </Box>
      
{/* Contact Section - WhatsApp Only */}
<Box 
  id="contacto"
  sx={{ 
    py: 8, 
    bgcolor: 'primary.main', 
    color: 'primary.contrastText',
    textAlign: 'center'
  }}
>
  <Container maxWidth="md">
    <Typography variant="h4" component="h2" gutterBottom fontWeight="bold">
      ¿Listo para potenciar tu negocio?
    </Typography>
    <Typography variant="h6" paragraph sx={{ maxWidth: '800px', mx: 'auto', mb: 6, fontWeight: 'normal' }}>
      Contáctanos directamente a través de WhatsApp y descubre cómo nuestras soluciones 
      pueden transformar tu negocio de servicios streaming.
    </Typography>
    
    <Paper 
      elevation={4} 
      sx={{ 
        p: 5, 
        borderRadius: 3, 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        maxWidth: '600px',
        mx: 'auto'
      }}
    >
      <Box 
        sx={{ 
          width: 100,
          height: 100,
          borderRadius: '50%',
          bgcolor: '#25D366',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mb: 3,
          boxShadow: 2
        }}
      >
        <WhatsApp 
          sx={{ 
            fontSize: 60, 
            color: 'white'
          }} 
        />
      </Box>
      
      <Typography variant="h5" gutterBottom fontWeight="bold" color="text.primary">
        Comunicación directa por WhatsApp
      </Typography>
      
      <Typography variant="body1" sx={{ mb: 4, maxWidth: '450px' }} color="text.secondary">
        Respuesta rápida y personalizada. Cuéntanos sobre tu proyecto o servicio que te interesa y te ayudaremos a encontrar la solución ideal.
      </Typography>
      
      <Button 
        variant="contained" 
        size="large"
        startIcon={<WhatsApp />}
        href={`https://wa.me/523122145108?text=Hola,%20me%20interesa%20saber%20más%20sobre%20sus%20servicios`}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ 
          bgcolor: '#25D366',
          '&:hover': {
            bgcolor: '#128C7E'
          },
          borderRadius: 2,
          px: 5,
          py: 2,
          fontWeight: 600,
          boxShadow: 4,
          fontSize: '1.1rem',
          textTransform: 'none'
        }}
      >
        Contáctanos ahora
      </Button>
      
      <Typography variant="body2" sx={{ mt: 4, fontSize: '1rem' }} color="text.secondary">
        +52 312 214 5108
      </Typography>
    </Paper>
  </Container>
</Box>
      
      {/* Footer - similar to Tailwind design */}
      <Box sx={{ bgcolor: 'grey.900', color: 'grey.400', py: 4 }}>
        <Container>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography variant="h6" component="h2" sx={{ color: 'white', mb: 1, fontWeight: 'bold' }}>
                StreamingSoft
              </Typography>
              <Typography variant="body2">
                Soluciones especializadas para negocios de streaming
              </Typography>
            </Grid>
            
            <Grid item xs={12} md={6}>
              <Box 
                sx={{ 
                  display: 'flex', 
                  gap: 3, 
                  justifyContent: { xs: 'center', md: 'flex-end' }
                }}
              >
                <Button color="inherit" href="#servicios" size="small" sx={{ '&:hover': { color: 'white' } }}>Servicios</Button>
                <Button color="inherit" href="#clientes" size="small" sx={{ '&:hover': { color: 'white' } }}>Clientes</Button>
                <Button color="inherit" href="#contacto" size="small" sx={{ '&:hover': { color: 'white' } }}>Contacto</Button>
              </Box>
            </Grid>
          </Grid>
          
          <Divider sx={{ my: 3, borderColor: 'grey.800' }} />
          <Typography variant="body2" align="center">
  Desarrollado por StreamingSoft by{' '}
  <a 
    href="https://celerisoft.com" 
    target="_blank" 
    rel="noopener noreferrer" 
    style={{ color: 'green' }}
  >
    Celerisoft
  </a>
</Typography>
          <Typography variant="body2" align="center">
            &copy; {new Date().getFullYear()} Todos los derechos reservados
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default LandingPage;